import { usePage } from './pages/PageContext'
import { whatsAppUrlFor } from './siteDestinations'

/** Atalho flutuante: abre o WhatsApp com a mensagem da página atual, para Arthur saber de onde a pessoa veio. */
export default function FloatingWhatsAppButton() {
  const { whatsappMessage } = usePage()

  return (
    <a
      className="floating-whatsapp"
      href={whatsAppUrlFor(whatsappMessage)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Conversar com Arthur no WhatsApp"
    >
      <svg viewBox="0 0 32 32" aria-hidden="true">
        <path d="M16 3.2A12.5 12.5 0 0 0 5.1 21.8L3.5 28.5l6.8-1.6A12.5 12.5 0 1 0 16 3.2Zm0 22.7c-2 0-4-.6-5.7-1.7l-.4-.2-4 .9 1-3.9-.3-.4A10.2 10.2 0 1 1 16 25.9Zm5.6-7.6c-.3-.2-1.8-.9-2.1-1s-.5-.2-.7.2-.8 1-1 1.2-.4.2-.7.1a8.3 8.3 0 0 1-2.5-1.5 9.4 9.4 0 0 1-1.7-2.1c-.2-.3 0-.5.1-.7l.5-.5.3-.6c.1-.2 0-.4 0-.6l-1-2.3c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4s-1.2 1.2-1.2 2.9 1.2 3.3 1.4 3.5c.1.2 2.4 3.7 5.9 5.2.8.4 1.5.6 2 .7.8.3 1.6.2 2.2.1.7-.1 1.8-.7 2.1-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4Z" />
      </svg>
      <span>Falar no WhatsApp</span>
    </a>
  )
}
